//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Amylase',
  data() {
    return {
      form: {
        input: ''
      },
      hasScore: false,
      disabled: false
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
   computed: {
      /** 计算公式结果 */
      score() {
        let self = this
        let form = JSON.parse(JSON.stringify(self.form))
        let flag = true
        for (const key in form) {
          if (form.hasOwnProperty(key)) {
            if (!form[key]) {
              flag = false
            } else { 
              if (form[key]=='---') {
                flag = false
              } else {  
                form[key] = Number(form[key])
              }
            }
          }
        }
        if (!flag) {
          self.hasScore = false
          return '--'
        } else {  
          // gender==0 ?	(fh + mh + 13) / 2 :	(fh + mh - 13) / 2
          let result = form.input
          self.hasScore = true
          return String(result.toFixed(5))
        }
      }
    },
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/Amylase.vue